<template>
  <Popover>
    <PopoverTrigger as-child>
      <button class="filter-trigger" data-testid="job-list-status-filter">
        <ListFilterIcon class="h-3.5 w-3.5" />
        <span>{{ selectedStatus }}</span>
        <ChevronDown class="h-3.5 w-3.5 text-gray-400" />
      </button>
    </PopoverTrigger>

    <PopoverContent align="end" class="w-56 p-1.5" :side-offset="8">
      <div class="space-y-1">
        <div class="px-2 pb-1 text-[11px] font-medium uppercase tracking-[0.08em] text-gray-500">Job status</div>
        <button
          v-for="option in statusOptions"
          :key="option"
          class="filter-row"
          :class="{ 'filter-row-active': statusFilter?.value === option }"
          @click="$emit('update-filter', buildFilters(option))"
        >
          <span>{{ option }}</span>
          <CheckIcon v-if="statusFilter?.value === option" class="h-3.5 w-3.5" />
        </button>
      </div>
    </PopoverContent>
  </Popover>
</template>

<script>
import { CheckIcon, ChevronDown, ListFilterIcon } from 'lucide-vue-next';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

export default {
  components: {
    CheckIcon,
    ChevronDown,
    ListFilterIcon,
    Popover,
    PopoverContent,
    PopoverTrigger,
  },
  props: {
    filters: {
      type: Array,
      required: true,
    },
  },
  emits: ['update-filter'],
  computed: {
    statusFilter() {
      return this.filters.find(f => f.key === 'status');
    },
    selectedStatus() {
      if (!this.statusFilter || !this.statusFilter.value || this.statusFilter.value === 'All') {
        return 'All statuses';
      }

      return `Status: ${this.statusFilter.value}`;
    },
    statusOptions() {
      return ['All', 'Active', 'Inactive'];
    },
  },
  methods: {
    buildFilters(value) {
      return {
        status: {
          ...(this.statusFilter || { key: 'status' }),
          value,
        },
      };
    },
  },
};
</script>

<style scoped>
@reference "tailwindcss";

.filter-trigger {
  @apply inline-flex items-center gap-1.5 rounded-md px-0 py-0 text-sm font-medium text-gray-500 transition-colors hover:text-gray-900;
}

.filter-row {
  @apply flex w-full items-center justify-between rounded-md px-2 py-1.5 text-sm text-gray-600 transition-colors hover:bg-gray-50 hover:text-gray-900;
}

.filter-row-active {
  @apply bg-gray-100 font-medium text-gray-900;
}
</style>
